import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  AddressError,
  AddressLookupCountries,
  AddressLookupCountry,
  Address,
} from '../models';
import { AddressifyService } from './addressify.service';
import { GooglePlacesService } from './googleplaces.service';
import { AddressibleService } from './addressible.service';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupService {
  constructor(
    private addressify: AddressifyService,
    private googleplaces: GooglePlacesService,
    private addressibleService: AddressibleService
  ) {}

  hasLookup(country: string): country is AddressLookupCountry {
    return !!country && AddressLookupCountries.includes(country);
  }

  search(term: string, country: AddressLookupCountry = 'Australia') {
    if (!this.hasLookup(country)) {
      return of({
        code: 0,
        message: `Country ${country} has no lookup service defined`,
      } as AddressError);
    }

    let req$: Observable<Address[] | AddressError>;

    switch (country) {
      case 'Australia':
        req$ = this.addressify.autocomplete(term);
        break;
    }

    return req$.pipe(
      catchError((err: any) => {
        const htmlErr = err as HttpErrorResponse;
        return of({
          code: htmlErr.status,
          message: htmlErr.message,
        } as AddressError);
      })
    );
  }
}
